import React, { Fragment } from "react";
import styled from "styled-components";
import { Styles } from "../../../config";
import { Flex } from "../../../container-components";
import { Typography } from "../../../typo-components";
import { BlockButton, BotImage } from "./StyledComponents";

export const MessageContainerHeader = styled.div`
  background: ${props => props.chatbotConfig.type === 'calendly' ? 'transparent' : Styles.Color.primary};
  width: 100%;
  max-height: 60px;
  height: 100%;
  border-radius: 5px 5px 0 0;
  position: absolute;
  top: 0;
  left: 0;
  padding: ${(props) => (props.isInline ? "0 0 20px" : "10px 0 0")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${(props) => (props.isInline ? "flex-end" : "center")};
  z-index: ${props => props.chatbotConfig.type === 'calendly' ? -1 : 1};

  transition: ${(props) =>
    props.chatbotConfig?.type !== "main" && "max-height 300ms ease-in-out"};

  @media (max-width: 800px) {
    border-radius: 0px;
  }
`;


const BotHeader = ({
  handleMessageButtonClick,
  setOpenChat,
  isInline,
}) => {
  return (
    <Flex yAlign="flex-start" width="90%">
      {isInline ? (
        <Typography margin="0 0 0 10px" color="white" variant="t5">
          Connect with us
        </Typography>
      ) : (
        <Fragment>
          <BotImage src="/assets/images/chatbot/Salusion1024.jpg"></BotImage>
          <Typography margin="0 0 0 10px" color="white" variant="t6">
            Salusion Support
          </Typography>

          <BlockButton
            margin="0 0 0 auto"
            onClick={() => setOpenChat(false)}
          >
            {" "}
            <i style={{ color: "white" }} className="material-icons">
              {" "}
              close
            </i>
          </BlockButton>
        </Fragment>
      )}
    </Flex>
  );
};

const ContactHeader = ({
  handleMessageButtonClick,

  setOpenChat,
  isInline,
  resetChat,
}) => {
  return (
    <Flex yAlign="flex-start" width="90%">
      <BlockButton
        onClick={() => {
          handleMessageButtonClick({ type: "bot" });
          resetChat();
        }}
      >
        {" "}
        <i style={{ color: "white" }} className="material-icons">
          {" "}
          keyboard_arrow_left
        </i>
      </BlockButton>
      {/* <BotImage src="/assets/images/chatbot/kate.jpg"></BotImage> */}
      <Typography margin="0 0 0 10px" color="white" variant="t6">
        Contact Us
      </Typography>
      {!isInline && (
        <BlockButton
          margin="0 0 0 auto"
          onClick={() => setOpenChat(false)}
        >
          {" "}
          <i style={{ color: "white" }} className="material-icons">
            {" "}
            close
          </i>
        </BlockButton>
      )}
    </Flex>
  );
};


const Header = ({
  chatbotConfig,
  handleMessageButtonClick,
  setOpenChat,
  isInline,
  resetChat,
}) => {


  let StageHeader = (
    <BotHeader
      handleMessageButtonClick={handleMessageButtonClick}
      setOpenChat={setOpenChat}
      isInline={isInline}
    ></BotHeader>
  );
  if (chatbotConfig?.type === "contact")
    StageHeader = (
      <ContactHeader
        handleMessageButtonClick={handleMessageButtonClick}
        setOpenChat={setOpenChat}
        isInline={isInline}
        resetChat={resetChat}
      ></ContactHeader>
    );
  else if (chatbotConfig?.type === "calendly")
    StageHeader = <Fragment />
  //  (
  //   <CalendlyHeader
  //     handleMessageButtonClick={handleMessageButtonClick}
  //     setOpenChat={setOpenChat}
  //     isInline={isInline}
  //     resetChat={resetChat}
  //   ></CalendlyHeader>
  // );
  return (
    <MessageContainerHeader
      setOpenChat={setOpenChat}
      chatbotConfig={chatbotConfig}
      isInline={isInline}
    >
      {StageHeader}
    </MessageContainerHeader>
  );
};

export default Header;
